import { render, staticRenderFns } from "./m-retailer-screen.vue?vue&type=template&id=4c86e5a2&"
import script from "./m-retailer-screen.vue?vue&type=script&lang=js&"
export * from "./m-retailer-screen.vue?vue&type=script&lang=js&"
import style0 from "./m-retailer-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports